import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface Partner {
  id: string;
  name_ar: string;
  name_en: string;
  image_url: string | null;
}

export const ParticipatingEntities = ({ isRTL }: { isRTL: boolean }) => {
  const [entities, setEntities] = useState<Partner[]>([]);

  useEffect(() => {
    supabase
      .from("partners")
      .select("id,name_ar,name_en,image_url")
      .order("display_order", { ascending: true })
      .then(({ data }) => setEntities(data || []));
  }, []);

  if (entities.length === 0) return null;

  return (
    <section className="py-16 bg-muted">
      <div className="container">
        <h2 className="text-3xl font-bold mb-12 text-center">
          {isRTL ? "الجهات المشاركة" : "Participating Entities"}
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {entities.map((entity) => (
            <div
              key={entity.id}
              className="flex flex-col items-center justify-center p-6 bg-white rounded-xl hover:shadow-lg transition-shadow"
            >
              <div className="w-32 h-32 relative">
                {entity.image_url && (
                  <img
                    src={entity.image_url}
                    alt={isRTL ? entity.name_ar : entity.name_en}
                    className="w-full h-full object-contain"
                  />
                )}
              </div>
              <h3 className="mt-4 text-center text-sm text-muted-foreground">
                {isRTL ? entity.name_ar : entity.name_en}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
